import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

export type ProPilotStatus = "off" | "docked" | "floating";

type State = { status: ProPilotStatus };
type Actions = {
  dock: () => void;
  float: () => void;
  turnOff: () => void;
};
type ProPilotLifecycleStore = State & { actions: Actions };

const useProPilotLifecycleStore = create<ProPilotLifecycleStore>((set) => ({
  status: "off",
  actions: {
    dock: () => set({ status: "docked" }),
    float: () => set({ status: "floating" }),
    turnOff: () => set({ status: "off" })
  }
}));

export const useProPilotStatus = (): ProPilotStatus => useProPilotLifecycleStore((state) => state.status);

export const useProPilotLifecycleActions = () =>
  useProPilotLifecycleStore(useShallow((state) => state.actions));
